import { buildPageMetadata, metadataTags } from '../../functions/publicMetadataPolicy.js';

export function applyPageMetadata(profile, pathname, options) {
    const metadata = buildPageMetadata(profile, pathname, options);
    document.title = metadata.title;
    metadataTags(metadata).forEach(([attribute, key, value]) => {
        const selector = `meta[${attribute}="${key}"]`;
        const existing = Array.from(document.head.querySelectorAll(selector));
        const tag = existing.shift();
        existing.forEach(duplicate => duplicate.remove());
        if (value == null) {
            tag?.remove();
            return;
        }
        const element = tag || document.createElement('meta');
        element.setAttribute(attribute, key);
        element.setAttribute('content', value);
        if (!tag) document.head.appendChild(element);
    });
    const existingCanonicals = Array.from(document.head.querySelectorAll('link[rel="canonical"]'));
    if (!metadata.canonical) {
        existingCanonicals.forEach(element => element.remove());
        return;
    }
    const canonical = existingCanonicals.shift() || document.createElement('link');
    existingCanonicals.forEach(duplicate => duplicate.remove());
    canonical.rel = 'canonical';
    canonical.href = metadata.canonical;
    if (!canonical.parentNode) document.head.appendChild(canonical);
}

export function resetPageMetadata(pathname) {
    // Preserve server-supplied Space metadata on the initial page load.
    const url = buildPageMetadata(null, pathname).url;
    if (document.head.querySelector('meta[property="og:url"]')?.content !== url) {
        applyPageMetadata(null, pathname);
    }
}
